import './App.css';
import {useState, useEffect} from "react"
import CounterDisplay from './containers/counter-display';
import Settings from './containers/settings';

function App() {

  const defaultPomodoroDuration = 25 * 60;
  const defaultRestDuration = 5 * 60;

  const [timer, setTimer] = useState(defaultPomodoroDuration)
  const [run, setRun] = useState(false)
  const [restTime, setRestTime] = useState(false)
  const [numberPomodoro, setNumberPomodoro] = useState(0)
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    let interval;
    if (run) {
      interval = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [run]);

  useEffect(() => {
    const body = document.body;
    if (darkMode) {
      body.classList.add('dark-body');
      body.classList.remove('light-body');
    } else {
      body.classList.add('light-body');
      body.classList.remove('dark-body');
    }
  }, [darkMode]);

  const handleTimerComplete = () => {
    setRun(false);
    setRestTime(true);
    setTimer(defaultRestDuration);

    const updatedPomodoros = numberPomodoro + 1;
    setNumberPomodoro(updatedPomodoros);

    if (updatedPomodoros === 4) {
      setNumberPomodoro(0);
      setTimer(15*60);
    }
  };

  useEffect(() => {
  if (timer === 0 && !restTime) {
    handleTimerComplete();
  } else if (timer === 0 && restTime) {
    handleRestComplete();
  }
}, [timer, restTime]);

  const handleRestComplete = () => {
  setRun(false);
  setRestTime(false);
  setTimer(defaultRestDuration);
};

  const start = () => {
    if (!run) {
      if (timer === 0 && restTime) {
        setRestTime(false);
        setTimer(defaultPomodoroDuration);
      } else if (timer === 0 && !restTime) {
        setRestTime(true);
        setTimer(defaultRestDuration);
      } else {
        setRun(true);
      }
    }
  };

  const stop = () => {
    setRun(false)
  }

  const converTime = (seg) => {
    const minutes = Math.floor(seg / 60)
    const seconds = Math.floor(seg % 60);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  return (
      <div className={darkMode ? "body" : "light-body"}>
        <Settings darkMode={darkMode} setDarkMode={setDarkMode}></Settings>
        <CounterDisplay
          darkMode={darkMode}
          run={run}
          converTime={converTime}
          timer={timer}
          restTime={restTime}
          start={start}
          stop={stop}
        ></CounterDisplay>
      </div>
  );
}

export default App;
